<template>
  <div class="main-content">
    <CSeats 
      :seats="seats"
      :forceUpdate="forceUpdate"
      :algoSelected="algoSelected"
      @NbSeatsChanged="emitNbSeatsChanged"
      @NewRow="emitNewRow"
      @ContextualHelpChanged="emitContextualHelpChanged"
    ></CSeats>

    <CLayers
      :algoSelected="algoSelected"
      :algoList="algoList"
      :layerColors="layerColors"
      :layerSelected="layerSelected"
      :mlpRow="mlpRow"
      :mlpCol="mlpCol"
      :mlpID="mlpID"
      @AlgoChanged="emitAlgoChanged"
      @LayerChanged="emitLayerChanged"
      @ContextualHelpChanged="emitContextualHelpChanged"
    ></CLayers>

    <CPoints 
      :nbPoints="nbPoints"
      :maxNbPoints="maxNbPoints"
      :algoSelected="algoSelected"
      @MaxPointChanged="emitMaxPointChanged"
      @ContextualHelpChanged="emitContextualHelpChanged"
    ></CPoints>

  </div>
</template>

<script>
import CSeats from "@/components/measures/settings/CSeats.vue";
import CLayers from "@/components/measures/settings/CLayers.vue";
import CPoints from "@/components/measures/settings/CPoints.vue";
export default {
  name: "CSettings",
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  components: {
    CSeats,
    CLayers,
    CPoints
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  props: {
    seats: Array,
    forceUpdate: Boolean,
    algoSelected: String,
    algoList: Array,
    layerColors: Array,
    layerSelected: Number,
    mlpRow: Number,
    mlpCol: Number,
    nbPoints: Number,
    mlpID: Number,
    maxNbPoints: Number
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  methods: {
    emitNbSeatsChanged: function(event) {
      this.$emit("NbSeatsChanged", event);
    },
    ///////////////////////////////////////////////////////////////
    emitNewRow: function() {
      this.$emit("NewRow");
    },
    ///////////////////////////////////////////////////////////////
    emitAlgoChanged: function(event) {
      this.$emit("AlgoChanged", event);
    },
    ///////////////////////////////////////////////////////////////
    emitLayerChanged: function(event) {
      this.$emit("LayerChanged", event);
    },
    ///////////////////////////////////////////////////////////////
    emitMaxPointChanged: function(event) {
      this.$emit("MaxPointChanged", event);
    },
    ///////////////////////////////////////////////////////////////
    emitContextualHelpChanged: function(event) {
      this.$emit("ContextualHelpChanged", event);
    }
  }
}
</script>

<style lang="scss" scoped>
@include setMainContent(81vh)
</style>